import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import axios from "axios";
import ToastModal from "views/components/ToastModal";
import ConfirmationModal from "views/components/ConfirmationModal";
import { headerLabel } from "assets/properties/properties";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { checkForRepledgeAccount } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";

const InsuranceESign = ({ 
  setNext, 
  setBack, 
  loanApplicationId, 
  classes, 
  closeModal , 
  isEsign, 
  alreadyEsigned, 
  setAlreadyEsigned,
  esingDisable, 
  setEsignDisable,
  featureFlags,
  loanType,
  prePledgeLoan
}) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('')
  const [preview, setPreView] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [message, setMessage]= useState('');
    const outletData = featureFlags;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const [esignLetterState , setEsignLetterState] = useState(false);
  const navigate=useNavigate()
  const handleNext = () => {
    setNext();
  };
  const handleBack = () => {
    setBack();
  };
  useEffect(() => {
    if(isEsign && !esingDisable){
      const interval = setInterval(async () => {
        const res = await apiHandler({
          url: endpoint.GET_ESIGN_INSURANCE_LETTER + loanApplicationId,
          method: "GET",
          authToken: authToken,
        });
        setCallInProgress(false);
        if ((res?.data?.status === "COMPLETED" || res?.data?.status === "DONE" )&& res?.data?.fileLink) {
         
          GetPreviewLink(res?.data?.fileLink)
          clearInterval(interval);
          setEsignDisable(false)
        } else if(res?.data?.status === "REJECTED"){
          setMessage("Your Sanction Letter is Rejected. Please Esign Again");
          setEsignDisable(false)
        }
      },10000);
      return () => {
        clearInterval(interval);
      };
    }else{
      GetSanctionLetter();
    }
  }, []);
  const GetPreviewLink = async (letterLink) =>{
    setPreView(letterLink);
  }
  const GetSanctionLetter = async () => {
    //SANCTION_LETTER
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.insuranceLetterLink) {
      const selectedLetter = res?.data?.insuranceLetterLink;
      setPreView(selectedLetter);
    }
  };
  const proceedApplication = () => {
    if(message){
      toastUpdate("Error", "Sanction Letter has rejected. Please Esign again", true);
    }else if(!preview){
      toastUpdate("Error", "Please Esign or Upload the Sanction Letter", true);
    }else{
    setConfirmationModalHeader("Disbursal");
    setConfirmationModalMsg(
      "Are you sure you want to Proceed this Loan to LMS"
    );
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  }
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
    onClickProceedData(id);
  };
  const onClickProceedData = async (id) => {
    setCallInProgress(true);
    if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
      const checkResult = await checkForRepledgeAccount(authToken, prePledgeLoan);
      if(checkResult?.data?.error_code){
        toastUpdate("Error",checkResult?.data?.user_description,true);
        return;
      }else{
        const filteredData = checkResult?.data?.filter(item => Number(item?.id) !== Number(id)) || [];
         if (Array.isArray(filteredData) && filteredData.length > 0) {
          const ids = filteredData
            .map(item => item?.id)
            .filter(Boolean);
          const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
          toastUpdate(
            "Error",
            `Already Repledge Loan Present with ${idsText}`,
            true
          );
          return false;
        }
      }
  }
    const result = await apiHandler({
    url: endpoint.DISBURSAL_APPLICATION_LMS + id + `?newDisbursement=true`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
        navigate("/loanservice/disbursLms", { state: { from: '' } });
    }
  };
  return (
    <div>
      <GridContainer>
         <GridItem item xs={12}>
        <SubHeader
           label={headerLabel?.insuranceEsign}
            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
            onlyLabel/>
      </GridItem>
      </GridContainer>
      <hr />
      
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {preview || !isEsign || alreadyEsigned ? <iframe src={preview} width="100%" height="500px" />
          :
          <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            textAlign: "center",
            marginTop: 50,
          }}
        >
          <h4>
            Document Send for signing. Please authorize yourself
            in another Tab and come back.
          </h4>
          <br />
          <CircularProgresss />
          <br />
          <h6>Do Not refresh this screen.</h6>
        </GridItem>
        }
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "end" }}>
          <Button
            size="small"
            className={classes.nextButton1}
            disabled={callInProgress}
            onClick={() => handleBack()}
          >
            Back
          </Button>
          <Button
            size="small"
            className={classes.nextButton}
            disabled={callInProgress}
            onClick={() =>proceedApplication()}
          >
            {"Submit"}
          </Button>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
          {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
    </div>
  );
};

InsuranceESign.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  closeModal: PropTypes.func,
};

export default InsuranceESign;